module.exports = __webpack_public_path__ + "assets/img/5.48b80845.png";